/**
 * egitimBaglam.js — kullanım turunun bağlam kimlikleri (services/egitimTuru.js). Bağımlılığı olmayan küçük bir dosya: pencereler
 * (`data-tour-baglam` işareti) kimliği buradan alır, böylece bir pencereyi içe aktarmak turun servislerini (portalService,
 * i18n kurulumu) beraberinde çekmez.
 *
 * `onay.*`: onay geçidi ve onun iki penceresi; `sayfa.*`: bir portal sayfası; `kart.*`: Firma Kartı'nın sekmeleri;
 * `pencere.*`: bir sayfadan açılan pencere. Açık bir pencerenin bağlamı pencerenin kendi `data-tour-baglam` işaretinden gelir.
 */
export const BAGLAM = {
  ONAY: 'onay.gecit',
  ONAY_KVKK: 'onay.kvkk',
  ONAY_KURALLAR: 'onay.kurallar',
  ANASAYFA: 'sayfa.anasayfa',
  KART_BILGILER: 'kart.bilgiler',
  KART_YETKILILER: 'kart.yetkililer',
  KART_EVRAKLAR: 'kart.evraklar',
  STANDLAR: 'sayfa.standlar',
  TALEPLER: 'sayfa.talepler',
  PERSONEL: 'sayfa.personel',
  PERSONEL_EKLE: 'pencere.personelEkle',
};
